const MoneyHelper = {
    format(number, decimalLength = 2, sectionDelimiter = '.', decimalLimiter = ',') {
        const parsedNumber = parseFloat(number);
        if (!isNaN(parsedNumber)) {
            const re = '\\d(?=(\\d{' + 3 + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')';
            const num = parsedNumber.toFixed(Math.max(0, Math.floor(decimalLength)));

            return num.replace('.', decimalLimiter).replace(new RegExp(re, 'g'), '$&' + (sectionDelimiter || ','));
        } else {
            return '';
        }
    },
};

module.exports = MoneyHelper;
